import React, { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import "./styles.css";
import Profile from "./components/Profile";

const root = createRoot(document.getElementsByClassName("profile")[0]);
root.render(
      <BrowserRouter>
        <Profile 
          profileUrl={
            {
              fr: "./profile-fr.json",
              en: "./profile.json"
            }
          }
          options={{
            identity: {
              language: "en"
            } 
          }}
        />
      </BrowserRouter>
    );



